import { render, staticRenderFns } from "./DiscountCreateEditModal.vue?vue&type=template&id=641669b8&scoped=true&"
import script from "./DiscountCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./DiscountCreateEditModal.vue?vue&type=script&lang=js&"
import style0 from "./DiscountCreateEditModal.vue?vue&type=style&index=0&id=641669b8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641669b8",
  null
  
)

export default component.exports